import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";

export const useChart = () => {
  const [chartData, setChartData] = useState(null);
  const [monthYear, setMonthYear] = useState("");
  const [roomNightChartData, setRoomNightChartData] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const response = await axios.get("/api/bookings/chart/month");
        const { dates, counts, month, year } = response.data;

        setMonthYear(`${month} ${year}`);
        setChartData({
          labels: dates,
          datasets: [
            {
              label: "Bookings",
              data: counts,
              backgroundColor: "rgba(63, 81, 181, 0.6)",
              borderColor: "rgba(63, 81, 181, 1)",
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching booking chart data:", error);
      }
    };

    fetchChartData();
  }, []);

  useEffect(() => {
    const fetchRoomNightChartData = async () => {
      try {
        const response = await axios.get("/api/bookings/chart/roomnight");
        const { dates, roomNights, month, year } = response.data;

        // Set month and year for the title
        setMonthYear(`${month} ${year}`);

        // Create a new array of all dates in the current month (even if no room nights are available)
        const allDates = [];
        const allRoomNights = [];

        // Ensure all dates of the month are included
        const daysInMonth = moment().daysInMonth();
        for (let i = 1; i <= daysInMonth; i++) {
          const date = moment().date(i).format("YYYY-MM-DD");
          allDates.push(date);

          // Check if the room nights data exists for the date
          const index = dates.indexOf(date);
          allRoomNights.push(index !== -1 ? roomNights[index] : 0); // Set to 0 if no data exists
        }

        // Set the room night chart data with the adjusted arrays
        setRoomNightChartData({
          labels: allDates,
          datasets: [
            {
              label: "Room Nights",
              data: allRoomNights,
              backgroundColor: "rgba(255, 99, 132, 0.6)", // Color for the chart
              borderColor: "rgba(255, 99, 132, 1)",
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching room night chart data:", error);
      }
    };

    fetchRoomNightChartData();
  }, []);

  return {
    chartData,
    monthYear,
    roomNightChartData,
  };
};
